import { ApolloClient } from 'apollo-client';
import { createLink } from 'apollo-absinthe-upload-link';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { setContext } from 'apollo-link-context';
import { Socket as PhoenixSocket } from 'phoenix';
import { split } from 'apollo-link';
import { createAbsintheSocketLink } from '@absinthe/socket-apollo-link';
import { hasSubscription } from '@jumpn/utils-graphql';
import * as AbsintheSocket from '@absinthe/socket';

const middlewareLink = setContext(() => ({
  headers: {
    authorization: `JWT ${localStorage.getItem('token')}`,
  },
}));

const v2HttpLink = createLink({ uri: process.env.GRAPHQL_COLONY_V2 });

const absintheSocketLink = createAbsintheSocketLink(
  AbsintheSocket.create(
    new PhoenixSocket(process.env.WS_COLONY_V2, {
      reconnect: true,
      params: { token: localStorage.getItem('token') },
    }),
  ),
);

const v2LinkWithSubscriptions = split(
  operation => hasSubscription(operation.query),
  absintheSocketLink,
  middlewareLink.concat(v2HttpLink),
);

export default new ApolloClient({
  link: v2LinkWithSubscriptions,
  cache: new InMemoryCache({ addTypename: false }),
  connectToDevTools: true,
});



// WEBPACK FOOTER //
// ./src/apiv2Client.js